import { T } from "../theme";

export default function Badge({ color = T.accent, size = "sm", children, dot = false }) {
  const isSm = size === "sm";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: dot ? 6 : 0,
        padding: isSm ? "2px 8px" : "4px 12px",
        fontSize: isSm ? 11 : 12,
        fontWeight: 600,
        fontFamily: T.fontBody,
        borderRadius: T.radiusFull,
        background: `${color}12`,
        color: color,
        lineHeight: 1.5,
        whiteSpace: "nowrap",
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: color,
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
}
